// Map/timeline colour encoding. Seven data kinds fold into three display groups: a map lets any two marks sit
// side by side, and three categorical hues is what stays distinguishable there (validated with the dataviz
// palette validator: dark mode, all pairs, surfaces #0b1016 / #10161e / #161d26 — worst CVD ΔE 8.5, normal 18.4).
// The legend is always shown, and names are labelled directly, so colour never carries identity alone.

export type RGB = [number, number, number];

export const GROUPS = [
  { key: "states", label: "Between states & empires", short: "States", hex: "#db2a3d" },
  { key: "internal", label: "Civil wars & insurgencies", short: "Civil wars", hex: "#c48300" },
  { key: "civilians", label: "Violence against civilians", short: "Civilians", hex: "#9a71e4" },
  { key: "other", label: "Other / unclassified", short: "Other", hex: "#7d8794" },
] as const;

// data kinds: 0 interstate, 1 civil, 2 colonial, 3 rebellion, 4 nonstate, 5 onesided, 6 other
export const KIND_GROUP = [0, 1, 0, 1, 1, 2, 3];
export const KIND_LABEL = ["Interstate war", "Civil war", "Colonial / imperial war", "Rebellion / insurgency",
  "Fighting between non-state groups", "Violence against civilians", "Armed conflict"];

export const hexToRgb = (hex: string): RGB => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16)) as RGB;
export const GROUP_RGB: RGB[] = GROUPS.map((g) => hexToRgb(g.hex));
export const groupOfKind = (kind: number) => KIND_GROUP[kind] ?? 3;
export const kindRgb = (kind: number): RGB => GROUP_RGB[groupOfKind(kind)];
export const kindHex = (kind: number): string => GROUPS[groupOfKind(kind)].hex;

// Named-event kinds: 0 battle, 1 siege, 2 naval, 3 massacre, 4 attack, 5 operation; UCDP 6/7/8; 9 uprising;
// 10 deportation.
export const EVENT_LABEL = ["Battle", "Siege", "Naval battle", "Massacre", "Attack / raid", "Military operation",
  "State-based violence", "Fighting between groups", "Violence against civilians", "Uprising", "Deportation"];

/** Colour of an event: massacres and one-sided violence are always "civilians"; otherwise its conflict's. */
export function eventGroup(eventKind: number, conflictKind: number | null): number {
  if (eventKind === 3 || eventKind === 8 || eventKind === 10) return 2;
  if (eventKind === 7) return 1;
  if (conflictKind == null) return eventKind === 9 ? 1 : 3; // a lone uprising is internal violence
  return groupOfKind(conflictKind);
}

export const HIGHLIGHT: RGB = [255, 255, 255];
